import React from "react";
import HealthMainContainer from "@components/_Revamp/HealthMainContainer";
import { ROUTE_PATH } from "@static/route-paths";
import { CCP_STEP_LIST } from "@static/content";
import { LinariaClassName } from "@linaria/core";
import { useAvivaSelector } from "@redux/hook";

interface Props {
  children: React.ReactNode;
  backButtonPath?: string;
  className?: LinariaClassName;
  currentStep?: string;
}

export const ContainerWithStepper: React.FC<Props> = ({
  children,
  backButtonPath,
  className,
  currentStep,
}) => {
  const cancerCoverStep4 = useAvivaSelector((state) => state.cancerCoverStep4);
  const isManual = cancerCoverStep4.singpassInitiatedOrManual === "MANUAL";
  const redirectUrl = isManual
    ? ROUTE_PATH.CANCER_COVER_MY_INFO +
      `?transaction_id=${cancerCoverStep4.myinfoTransactionId}&manual_data=available`
    : ROUTE_PATH.CANCER_COVER_MY_INFO +
      `?transaction_id=${cancerCoverStep4.myinfoTransactionId}`;

  return (
    <HealthMainContainer
      className={className}
      backButtonPath={backButtonPath}
      stepList={CCP_STEP_LIST.map((s) => {
        return {
          ...s,
          isCurrentStep: s.path === currentStep ? true : false,
          path:
            s.path === ROUTE_PATH.CANCER_COVER_MY_INFO ? redirectUrl : s.path,
        };
      })}
    >
      {children}
    </HealthMainContainer>
  );
};
